import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gl0043',
    ecrans: ['00-2'],
    params: ['id', 'eficleint']
});
